import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { toast } from 'react-toastify';
import PauseService from '../service';
import QueueService from '../../Queue/service';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import { useHistory } from 'react-router-dom';
import FlexSelect from 'components/Inputs/FlexSelect';
import { ScreenPrompt } from 'components/ScreenPrompt';

import {
  Container,
  Row,
  Card,
  Form,
  Col,
  Input,
  CardHeader,
  CardBody
} from 'reactstrap';
import ReactLoader from 'components/Loader';
import ReactButton from 'components/Buttons/ReactButton';

const PauseForm = (props) => {
  const history = useHistory();
  const { id } = props.match.params;

  const { reset, control, handleSubmit, errors, setValue, formState, watch } =
    useForm();
  const { isDirty } = formState;
  const enableToleranceCheck = watch('enableToleranceCheck');

  const [isUpdate, setIsUpdate] = useState(false);
  const [queues, setQueues] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    QueueService.getAll()
      .then((response) => {
        setQueues(response.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log('err: ' + err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (id) {
      setLoading(true);
      PauseService.get(id)
        .then((response) => {
          let getPause = response.data.data;

          let arrayQueuesId = [];
          getPause.queues.forEach((queue) => {
            arrayQueuesId.push(queue.id);
          });
          getPause = { ...getPause, queues: arrayQueuesId };

          reset(getPause);
          setIsUpdate(true);
          setLoading(false);
        })
        .catch((err) => {
          toast.error(err.response.data.message || 'Erro ao carregar pausa!', {
            autoClose: 3000,
            closeOnClick: true
          });
          setLoading(false);
        });
    }
  }, [id, reset]);

  const onSubmit = async (data) => {
    try {
      const formatedData = {
        ...data
      };

      isUpdate
        ? await PauseService.update(id, formatedData)
        : await PauseService.create(formatedData);
      history.push('/admin/pause');

      toast.success(
        isUpdate
          ? 'Pausa alterada com sucesso!'
          : 'Pausa cadastrada com sucesso!',
        {
          autoClose: 3000,
          closeOnClick: true
        }
      );
    } catch (err) {
      toast.error(err.response?.data?.message || 'Ops, ocorreu um erro!', {
        autoClose: 3000,
        closeOnClick: true
      });
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const cancelAction = () => {
    history.push('/admin/pause');
  };

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/pause"
        buttonTitle="Voltar para a pagina de pausas"
      />
      <ScreenPrompt
        when={isDirty && !formState.isSubmitting}
        message={`Está certo de que deseja sair? Terá que preencher os dados novamente quando retornar`}
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Pausa</h3>
                </CardHeader>
                <CardBody>
                  {loading ? (
                    <Row className="justify-content-md-center">
                      <ReactLoader />
                    </Row>
                  ) : (
                    <Form
                      className="needs-validation"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <Row className="mb-3">
                        <Col>
                          <h3 className="mb-1">Principal</h3>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col md="6">
                          <label className="form-control-label">Nome*</label>
                          <Controller
                            as={Input}
                            control={control}
                            name="name"
                            rules={{ required: 'Nome é obrigatório!' }}
                            defaultValue=""
                          />
                          <ErrorMessage
                            errors={errors}
                            name="name"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>

                        <Col md="6">
                          <label className="form-control-label">
                            Descrição
                          </label>
                          <Controller
                            as={Input}
                            control={control}
                            name="description"
                            defaultValue=""
                          />
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col md="6">
                          <label className="form-control-label">
                            Tempo de Alerta* (Segundos)
                          </label>
                          <Controller
                            as={Input}
                            control={control}
                            name="time_alert"
                            rules={{
                              required: 'Tempo de alerta é obrigatório!',
                              pattern: {
                                value: /^\d+$/,
                                message: 'Tempo de alerta é um campo numérico!'
                              }
                            }}
                            defaultValue=""
                          />
                          <ErrorMessage
                            errors={errors}
                            name="time_alert"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col className="md-6 mx-4">
                          <Controller
                            name="active"
                            control={control}
                            render={(props) => (
                              <>
                                <label className="form-control-label">
                                  <Input
                                    type="checkbox"
                                    onChange={(e) => {
                                      props.onChange(e.target.checked);
                                    }}
                                    checked={props.value}
                                  />
                                  Ativa
                                </label>
                              </>
                            )}
                            defaultValue=""
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col>
                          <h3 className="mb-1">Configurações</h3>
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md="6">
                          <label className="form-control-label">Fila(s)</label>
                          <Controller
                            render={(props) => (
                              <FlexSelect
                                dataOptions={queues}
                                isMulti={true}
                                isClearable={true}
                                value={props.value}
                                valueController={setValue}
                                fieldName="queues"
                                labelName="name"
                                valueName="id"
                              />
                            )}
                            control={control}
                            name="queues"
                            defaultValue=""
                            rules={{
                              required: 'Selecione as as filas da pausa!'
                            }}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="queues"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                      </Row>

                      <hr />
                      <ReactButton btnColor="confirmation" type="submit">
                        Salvar
                      </ReactButton>
                      <ReactButton
                        btnColor="cancelation"
                        onClick={() => cancelAction()}
                      >
                        Cancelar
                      </ReactButton>
                    </Form>
                  )}
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default PauseForm;
